<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#7e5678"
    :border="true"
    inactive-color="#979799"
    z-index="999"
  >
    <!-- Home -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/index.png' : '/img/footer/index.png'"
          :alt="$t('foorter.index')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/footer/index.png' : '/img/footer/index.png'"
          :alt="$t('foorter.index')"
          :class="$t('foorter.index')"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>

    <!-- Male -->
    <van-tabbar-item to="/Nanxin">
      <span>{{ $t("foorter.male") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/nan.png' : '/img/footer/nan.png'"
          :alt="$t('foorter.male')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/footer/nan.png' : '/img/footer/nan.png'"
          :alt="$t('foorter.male')"
          :class="$t('foorter.male')"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item>

    <!-- Female -->
    <van-tabbar-item to="/Nvai">
      <span>{{ $t("foorter.female") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/nv.png' : '/img/footer/nv.png'"
          :alt="$t('foorter.female')"
          v-show="show !== 2"
        />
        <img
          :src="props.active ? '/img/footer/nv.png' : '/img/footer/nv.png'"
          :alt="$t('foorter.female')"
          :class="$t('foorter.female')"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item>

    <!-- Benefits -->
    <van-tabbar-item to="/LotteryWindos">
      <span>{{ $t("foorter.benefits") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/fl.png' : '/img/footer/fl.png'"
          :alt="$t('foorter.benefits')"
          v-show="show !== 3"
        />
        <img
          :src="props.active ? '/img/footer/fl.png' : '/img/footer/fl.png'"
          :alt="$t('foorter.benefits')"
          :class="$t('foorter.benefits')"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item>

    <!-- Personal -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.personal") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/gr.png' : '/img/footer/gr.png'"
          :alt="$t('foorter.personal')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/footer/gr.png' : '/img/footer/gr.png'"
          :alt="$t('foorter.personal')"
          :class="$t('foorter.personal')"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "nanxin") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "nvai") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "LotteryWindos") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "nanxin") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "nvai") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "LotteryWindos") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
.van-tabbar {
  height: 14.667vw;
}
.van-tabbar-item__icon img {
  border-radius: 2vw;
  height: 6vw;
}
.van-tabbar-item {
  font-size: 3.2vw;
  line-height: 5.333vw;
}
.tui {
  width: 4rem;
  height: 4rem!important;
  margin-top: -7.333vw;
  background-color: white;
  border-radius: 50%;
  border: 1.333vw solid white;
  z-index: 10;
}
[class*="van-hairline"]::after {
  border: none !important;
}
</style>
